export default "__VITE_ASSET__BTcfV0fg__"